import React, { useEffect, useState } from "react";
import withRouter from "../Common/withRouter";
import BrandLogoDark from "../assets/images/logo.png";
import BrandLogoLight from "../assets/images/logo.png";
import './sidebarLayout.scss';
import dashboard from '../assets/images/dashboard_icon.svg';
import dashboardActive from '../assets/images/dashboard_icon_active.svg';
import businessInfo from '../assets/images/business_info_icon.svg';
import businessInfoActive from '../assets/images/business_info_icon_active.svg';
import liveAds from '../assets/images/live_ads_icon.svg';
import liveAdsActive from '../assets/images/live_ads_icon_active.svg';
import works from '../assets/images/works_icon.svg';
import worksActive from '../assets/images/works_icon_active.svg';
import catalog from '../assets/images/catalog_icon.svg';
import catalogActive from '../assets/images/catalog_icon_active.svg';
import mobileView from '../assets/images/mobile_view_icon.svg';
import mobileViewActive from '../assets/images/mobile_view_icon_active.svg';
import transaction from '../assets/images/transaction_icon.svg';
import transactionActive from '../assets/images/transaction_icon_active.svg';
import { Button, Menu } from "antd";
import { themecolor } from "../config.js";
import { StyleSimpleBar, StyleBrandLogo, StyleSider } from "../Common/SidebarStyle";
import { Link, useLocation } from "react-router-dom";
import Log from "../Services/Log.jsx";
import { useSelector } from "react-redux";

const SidebarLayout = ({ theme }) => {
  
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }
  let position = useLocation();
  const items = [
    getItem(<Link to="/dashboard" className="md">Dashboard</Link>, "dashboard",
      <div className="logo_wrap">
        <img src={dashboard} alt="" />
        <img src={dashboardActive} alt="" />
      </div>),
    getItem(<Link to="/my-profiles" className="md">My Profiles </Link>, "My Profiles",
      <div className="logo_wrap">
        <img src={liveAds} alt="" />
        <img src={liveAdsActive} alt="" />
      </div>),
      getItem(<Link to="/account-details" className="md">Account Details</Link>, "Account Details",
        <div className="logo_wrap">
          <img src={businessInfo} alt="" />
          <img src={businessInfoActive} alt="" />
        </div>)
    // getItem(<Link to="/transactions" className="md">Transactions</Link>, "transactions",
    //   <div className="logo_wrap">
    //     <img src={transaction} alt="" />
    //     <img src={transactionActive} alt="" />
    //   </div>)
  ];

  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  let businessInfoDetails = useSelector(state => state.BusinessInfoReducer?.businessInfo);
  const [warning , setWarning] = useState();

  useEffect(() => {
    if (businessInfoDetails) {
      setWarning(businessInfoDetails?.isProfileApprovedByAdmin);
    }
  }, [ businessInfoDetails]);

  useEffect(()=>{
    console.log('warning' , warning)
  },[warning])

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    const antHeaderMain = document.getElementById("antHeaderMain");
    if (antHeaderMain) {
      antHeaderMain.style.left = !collapsed ? "100px" : "260px";
    }
    const antLayoutContent = document.getElementById("antLayoutContent");
    if (antLayoutContent) {
      antLayoutContent.style.marginLeft = !collapsed ? "100px" : "260px";
    }
    const antFooterLayout = document.getElementById("antFooterLayout");
    if (antFooterLayout) {
      antFooterLayout.style.marginLeft = !collapsed ? "100px" : "260px";
    }
  };

  const getMainPath = (pathname) => {
    const paths = pathname.split('/');
    if (paths.includes('new-ads')) {
      return 'live-ads';
    }
    
    // Map path segments to menu keys
    const pathToKeyMap = {
      'dashboard': 'dashboard',
      'account-details': 'Account Details',
      'my-profiles': 'My Profiles'
    };
    
    const mainPath = paths[1] || 'dashboard';
    return pathToKeyMap[mainPath] || mainPath;
  };

  const [activatedItem, setActivatedItem] = useState(() => getMainPath(location.pathname));

  useEffect(() => {
    setActivatedItem(getMainPath(location.pathname));
  }, [location.pathname]);

  const toggleActivation = (key) => {
    setActivatedItem(key);
  };

  return (
    <React.Fragment>
      <StyleSider
        id="sidebar-layout"
        className={`sidebar-layout ${position.pathname === '/dashboard' ? 'dashboard_sidebar_layout' : 'common_sidebar_layout'}`}
        width={themecolor.components.Menu.verticalSidebarWidth}
        collapsed={collapsed}
        collapsedWidth="100"
        breakpoint="lg"
      >

        <StyleBrandLogo className="header_logo ant-mx-auto">
          <img
            alt="Brand logo"
            src={theme === 'dark' ? BrandLogoDark : BrandLogoLight}
            style={{ display: "block" }}
            className="brand-dark-logo ant-mx-auto img_full contain"
          />
        </StyleBrandLogo>
        <div>
        {/* <Button type="text" className="custom_close_button">Close</Button> */}
       <div className="text-center status_btn_wrap">
        {
          warning === 1 && (
            <span className="status_btn sm">Account Active</span>
          )
        }
           {/* {
          warning === 2 && (
            <span className="status_btn sm rejected">Account Rejected</span>
          )
        } */}
       </div>
          <StyleSimpleBar>
            <Menu
              selectedKeys={[activatedItem]}
              mode="inline"
              theme="light"
              items={items}
              collapsedWidth="100"
              onClick={({ key }) => toggleActivation(key)}
            ></Menu>
          </StyleSimpleBar>
        </div>
      </StyleSider>
    </React.Fragment>
  );
};

export default withRouter(SidebarLayout);
